import { render, staticRenderFns } from "./ContractProfileTemplatePanel.vue?vue&type=template&id=2b7378c9&scoped=true&"
import script from "./ContractProfileTemplatePanel.vue?vue&type=script&lang=ts&"
export * from "./ContractProfileTemplatePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7378c9",
  null
  
)

export default component.exports